import { useCallback, useEffect, useState } from 'react';
import { FIVE_SECONDS } from 'data/global';

/**
 * Blocks an action for a while after it's triggered, so it can't be fired over and over.
 *
 * The cooldown is dropped whenever `resetKey` changes — navigating to another file gives
 * a fresh button instead of one that's still locked from the previous file.
 */
export default function useClickCooldown(
  resetKey?: unknown,
  duration = FIVE_SECONDS,
) {
  const [isCoolingDown, setIsCoolingDown] = useState(false);

  const startCooldown = useCallback(() => setIsCoolingDown(true), []);

  useEffect(() => setIsCoolingDown(false), [resetKey]);

  useEffect(() => {
    if (!isCoolingDown) return;

    const timeout = setTimeout(() => setIsCoolingDown(false), duration);

    return () => clearTimeout(timeout);
  }, [isCoolingDown, duration]);

  return [isCoolingDown, startCooldown] as [boolean, () => void];
}
